import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/Button';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import Input from '../../../../components/Input';
import PhoneInput from '../../../../components/PhoneInput/PhoneInput';
import AppConfig from '../../../../config';
import HelperService from '../../../../services/HelperService';
import RequestService from '../../../../services/RequestService';
import { updateCardCreationDetails } from '../../../../store/slices/card/card';

import './InsertPersonalData.scss';

const { routes } = AppConfig;

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\+\d{8,15}$/;

const InsertPersonalData = () => {
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const {
		label,
		color,
		firstName = '',
		lastName = '',
		email = '',
		phone = '',
	} = useSelector(state => state.card.cardCreationDetails);

	const updateField = field => value => {
		dispatch(
			updateCardCreationDetails({
				[field]: value,
			})
		);
	};

	const createCard = async () => {
		const emptyCardSlideRoute = routes.mainPage + '#EmptyCard';
		try {
			setLoading(true);
			const response = await RequestService.CreateCard(label, color, firstName, lastName, email, phone);
			setLoading(false);
			dispatch(updateCardCreationDetails({ status: 'loading' }));

			if (response.Status === 'Success') {
				navigate(emptyCardSlideRoute);
			} else if (response.NeedVerify) {
				HelperService.verifyEmailPhone({
					verificationEmail: response.NeedVerifyEmail,
					verificationPhone: response.NeedVerifyPhone,
					successNotifficationText: null,
					successRedirectRoute: emptyCardSlideRoute,
				});
			} else {
				RequestService.BaseErrorFunc(response);
			}
		} catch (error) {
			RequestService.BaseErrorFunc(error);
		} finally {
			setLoading(false);
		}
	};

	const isFormValid = firstName.trim() && lastName.trim() && emailRegex.test(email) && phoneRegex.test(phone);

	const crossButton = (
		<Icon
			className='InsertPersonalData__cross-icon'
			onClick={() => updateField('email')('')}
			type={Icons.XMARK_CIRCLE_FILL}
			width={20}
			height={20}
		/>
	);

	return (
		<div className='InsertPersonalData'>
			{/* <PageHeader header='Your personal info' collapsed /> */}

			<div className='InsertPersonalData-form'>
				<Input
					className='FormBlock'
					placeholder='First name'
					value={firstName}
					onChange={e => updateField('firstName')(e.target.value)}
				/>

				<Input
					className='FormBlock'
					placeholder='Last name'
					value={lastName}
					onChange={e => updateField('lastName')(e.target.value)}
				/>

				<Input
					className='FormBlock'
					placeholder='Email'
					value={email}
					onChange={e => updateField('email')(e.target.value)}
					postfix={email ? crossButton : null}
				/>

				<PhoneInput value={phone} onChange={updateField('phone')} />

				<div className='InsertPersonalData-disclaimer'>
					<Icon
						className='InsertPersonalData__cross-icon'
						onClick={() => updateField('email')('')}
						type={Icons.INFO_CIRCLE}
						width={24}
						height={24}
					/>
					<span>
						A 3D Secure will be sent to your phone for payment confirmation, and receipts will be delivered to your
						email.
					</span>
				</div>

				<Button disabled={!isFormValid} onClick={createCard} loading={loading}>
					Continue
				</Button>
			</div>
		</div>
	);
};

export default InsertPersonalData;
